var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{staticClass:"img-entity",class:[("img-entity-" + _vm.type), ("img-entity-size-" + _vm.size)],attrs:{"src":_vm.src}}):_c('div',{staticClass:"img-entity",class:[("img-entity-" + _vm.type), ("img-entity-size-" + _vm.size)]})}
var staticRenderFns = []

export { render, staticRenderFns }